
<form [formGroup]="headerForm">
<input type="text" [placeholder]="title" *ngIf="device.isDesktopResolution$ | async; else headerTitleBlock" [formControlName]="formControlNames[title]" style="width: 100%; text-align: center" />
</form>
<ng-template #headerTitleBlock>{{ title }}</ng-template>
